const MIN_AGE = 18

const getDateYearsAgo = (yearsAgo: number) => {
  const now = new Date()

  return new Date(now.getFullYear() - yearsAgo, now.getMonth(), now.getDate())
}

const isTooYoung = (birthdate: Date) => {
  return birthdate > getDateYearsAgo(MIN_AGE)
}

export const validateTooYoung = (date: string | null | undefined) => {
  if (!date) return undefined

  const birthdate = new Date(date)

  return !isTooYoung(birthdate)
}
